import AdvanceSetting from "./AdvanceSetting";
import ShopInfo from "./ShopInfo";
import "./Setting.scss";
import UserTable from "./UserTable";
import ManagerSetting from "./Manager";
import {ManagerIconSettingSvg} from "../../Assets/svg";

export default function Setting(props) {

  const isAdmin = (localStorage.getItem("isAdmin") === "true" || localStorage.getItem("isAdmin") === true) ? true : false;

  return (
    <section className="py-1 setting">
      {/* <Header title={"تنظیمات"} /> */}
      <div className="container">
        <div className="bg-white shadow rounded-lg d-block ">
          <div className="profile-tab-nav border-right">
            <div className="burger-menu">
              <i className="fa fa-bars"></i>
            </div>
            <ul className="nav nav-pills" role="tablist">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  id="newuser-tab"
                  data-bs-toggle="pill"
                  href="#user-define"
                >
                  <i className="fa fa-home text-center mr-1"/> فهرست کاربران
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="store-spec"
                  data-bs-toggle="pill"
                  href="#store"
                >
                  <i className="fa fa-store text-center mr-1"/> مشخصات فروشگاه
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="print-tab"
                  data-bs-toggle="pill"
                  href="#advanced"
                >

                  <i className="fas fa-cogs text-center mr-1"/>
                  <span className={"px-1"}> تنظیمات پیشرفته</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="print-tab"
                  data-bs-toggle="pill"
                  href="#adminManageSection"
                >
                  {/*<i className="fas fa-cogs text-center mr-1" />*/}
                  <ManagerIconSettingSvg/>
                  <span className={"px-1"}>داشبورد مدیریتی</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="tab-content p-4 p-md-5">
            <div className="tab-pane  active" id="user-define">
              <UserTable/>
            </div>
            <div className="tab-pane fade" id="store">
              <ShopInfo/>
            </div>
            <div className="tab-pane fade" id="advanced">
              <AdvanceSetting isLog={false}/>
            </div>
            {isAdmin ? <div className="tab-pane fade" id="adminManageSection">
                <ManagerSetting/>
              </div> :
              <>
                <div className="tab-pane fade" id="adminManageSection">
                  <div className={"text-danger text-center"}> شما مجوز دسترسی به این بخش را ندارید.</div>
                </div>
              </>
            }
          </div>
        </div>
      </div>
    </section>
  );
}
